<template>
    <v-container
        class="vw-100 vh-100 bg-white text-dark d-flex flex-column"
        fluid
    >
        <transition name="collapsed-header">
            <header
                class="coach-header no-gutter flex-shrink-0 py-3 px-4"
                v-if="$route.name != 'CoachPage'"
            >
                <v-flex align="center">
                    <img
                        :src="page.coach.profile.profile_image.sizes.small"
                        class="profile-pic mr-3"
                    />
                    <router-link
                        :to="`/${page.username}`"
                        class="coach-header-name"
                    >
                        <h5 class="mb-0">
                            <b>{{ page.coach.account.full_name }}</b>
                        </h5>
                    </router-link>
                </v-flex>
            </header>
        </transition>
        <router-view :page="page" class="coach-view" />
        <ladder-footer class="no-gutter border-top" />
    </v-container>
</template>

<script>
import LadderFooter from "@/components/LadderFooter";

export default {
    name: "CoachLayout",
    components: {
        LadderFooter
    },
    props: {
        page: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            loaded: false
        };
    },
    async created() {
        document.body.classList.add("light");

        // Track this as a product listing in analytics
        if (window.analytics) {
            try {
                let products =
                    this.page.offers && this.page.offers.length
                        ? this.page.offers.map((offer, index) => {
                              return {
                                  product_id: offer.id,
                                  sku: offer.token,
                                  name: offer.full_name,
                                  price: offer.price,
                                  position: index,
                                  url: `https://app.joinladder.com/offer/${offer.token}`,
                                  category: "Coach Page Offer"
                              };
                          })
                        : [];

                window.analytics.track("Product List Viewed", {
                    list_id: this.page.username,
                    category: "Coach Page",
                    products
                });
            } catch (e) {
                // Silently fail
            }
        }
    },
    beforeDestroy() {
        document.body.classList.remove("light");
    }
};
</script>

<style scoped lang="scss">
.collapsed-header-leave-active {
    position: absolute;
    transform: translateY(0);
    opacity: 1;
    transition: all 600ms $curve;
}

.collapsed-header-leave-to {
    opacity: 0;
    transform: translateY(-100px);
}

.collapsed-header-enter-active {
    transform: translateY(-100px);
    opacity: 0;
    transition: all 600ms $curve;
}

.collapsed-header-enter-to {
    opacity: 1;
    transform: translateY(0px);
}

::v-deep .separator {
    width: 4rem;
    margin-left: 0px;
    background-color: $light;
}
.coach-header .profile-pic {
    height: 4rem;
    width: 4rem;
}
.coach-header {
    background-color: $dark;
}
.coach-header .profile-pic {
    height: 3rem;
    width: 3rem;
}
.coach-header-name {
    color: $light;
    text-decoration: none;
    transition: all 100ms linear;
}
.coach-header-name:hover {
    color: $white;
    transform: scale(1.025);
}
</style>
